import { ChatIcon } from './ChatIcon';

/**
 * author: Austin Andrews
 * id 7FF15164-E575-4024-ABAC-A183179F0217
 * name chat
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chat.svg
 * tags
 */
export const MessageBubbleIcon = ChatIcon;
export default MessageBubbleIcon